module.exports = __webpack_public_path__ + "img/picture_kmskcspvip04.a0937c47.png";